import { render, staticRenderFns } from "./JdsAttributeListLayout.vue?vue&type=template&id=8022de06&scoped=true&"
import script from "./JdsAttributeListLayout.vue?vue&type=script&lang=ts&"
export * from "./JdsAttributeListLayout.vue?vue&type=script&lang=ts&"
import style0 from "./JdsAttributeListLayout.vue?vue&type=style&index=0&id=8022de06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8022de06",
  null
  
)

export default component.exports